import { FormattedMessage } from 'react-intl'
import { DefaultTheme } from 'styled-components'
import { CABANAS_LIMIT } from 'constants/limits'
import Text from 'components/shared/Text'
import NumberPicker from 'components/shared/NumberPicker'
import { Wrapper } from './styles'

interface CabanaQuantityProps {
    quantity: number
    limit?: number
    setCabanaQuantity: (quantity: number) => void
    theme?: DefaultTheme
    index: number
}

export const CabanaQuantity = ({
    quantity,
    limit,
    setCabanaQuantity,
    theme,
    index,
}: CabanaQuantityProps) => {
    const hasDarkMode = theme?.mode === 'dark'

    return (
        <Wrapper
            mt={[24, 40]}
            mb={[24, 32]}
            pb={[16, 40]}
            gap={16}
            isFullWidth
            direction={['row', 'column']}
            align="flex-start"
            theme={theme}
        >
            <Text
                variant="heading4"
                color={hasDarkMode ? 'grayscale_200' : undefined}
            >
                <FormattedMessage
                    id="upsells.cabanas.quantity_label"
                    defaultMessage="Liczba Caban <span>2-osobowych</span>"
                    description="Please keep the html tags in the translation"
                    values={{
                        span: (chunks: string[]) => (
                            <Text
                                as="span"
                                variant="body"
                                color={
                                    hasDarkMode
                                        ? 'grayscale_400'
                                        : 'grayscale_700'
                                }
                            >
                                <br />
                                {chunks}
                            </Text>
                        ),
                    }}
                />
            </Text>
            <NumberPicker
                minValue={1}
                maxValue={limit || CABANAS_LIMIT}
                value={quantity}
                handleAdd={() => setCabanaQuantity(quantity + 1)}
                handleSubtract={() => setCabanaQuantity(quantity - 1)}
                theme={theme}
                isDisabled={!limit}
                testIdPrefix={`cabana-${index}`}
            />
        </Wrapper>
    )
}
